export const HIDE_NULLS = 'hideNulls';
export const SHOW_OVER_THRESHOLDS = 'showOverThresholds';
export const SHOW_ALL_NOTES = 'showAllNotes';
export const HAS_COMMENTS = 'hasComments';
export const HAS_BUDGET_DIFFERENCE = 'hasBudgetDifference';
